import React from "react";

import { IProps } from "./tabs-buttons.types";
import "./tabs-buttons.scss";

/**
 * Wrapper around buttons to change tabs.
 * @param props.children Tab buttons' content.
 * @returns              Tab buttons.
 */
const TabsButton = ({ children }: IProps) => <div className="tabs__buttons">{children}</div>;

export default TabsButton;
